import request from '../utils/request';
/**
 * @description: baner详情
 * @param {*} data 
 */
export function getBannerInfo(data) {
  return request({
    url: '/auth/bannerInfo',
    method: 'get',
    params: data,
  })
}